// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79ef13ba","239":"433e33d5","453":"96287a93","455":"cff15a1a"}[chunkId] + ".chunk.js";
};